import React, { Component } from 'react'
import { connect } from 'react-redux'
import { UPDATE_USER, SHOW_PAGE } from '../actions'
import Header from '../components/header'
import { t } from 'i18next'

import './form.css'

class Form extends Component {
  state = {
    sending: false,
    name: this.props.user.name,
    disabled: this.props.user.name !== ''
  }

  componentDidMount() {
    this.input.addEventListener('focus', this.autoScroll)
  }

  componentWillUnmount() {
    this.input.removeEventListener('focus', this.autoScroll)
  }

  autoScroll = e => {
    setTimeout(function() {
      document.activeElement.scrollIntoViewIfNeeded()
    }, 250)
  }

  sendToRanking() {
    let name = this.state.name
    name = name.trim()

    const { updateUser, updatePage } = this.props
    const { sending } = this.state

    if (name !== '' && !sending) {
      this.setState({
        sending: true
      })

      // update localstorage with last name
      updateUser({
        name
      })

      updatePage('nextWeek')
    }
  }

  onChange = e => {
    this.setState({
      name: e.target.value
    })
  }

  render() {
    // value for the input is the last name sent to the ranking
    const { user } = this.props
    const { sending, name, disabled } = this.state

    return (
      <div className="view-inner">
        <div className="score-holder text-center">
          <Header />
          <div className="gif-explosion" />
          <div className="score-content">
            <div className="score-intro">
              <div className="rounded rounded-md bg-gold flex-align-center">{user.score}</div>
              <h4>{t('form.success')}</h4>
            </div>
            <h1 className="score-message">{t('form.motivation')}</h1>
          </div>
          <div className="score-action">
            <input
              disabled={disabled}
              type="text"
              className="full enter-name"
              value={name}
              onChange={this.onChange}
              ref={r => (this.input = r)}
            />
            <button className="btn btn-blue btn-base full" disabled={sending} onClick={e => this.sendToRanking()}>
              {t('form.send')}
            </button>
          </div>
        </div>
      </div>
    )
  }
}

const mapState = state => {
  const { user } = state
  return {
    user
  }
}

const mapDispatch = dispatch => {
  return {
    updateUser: user => {
      dispatch({
        type: UPDATE_USER,
        payload: user
      })
    },

    updatePage: page => {
      dispatch({
        type: SHOW_PAGE,
        payload: page
      })
    }
  }
}
const FormConnect = connect(mapState, mapDispatch)(Form)
FormConnect.displayName = 'form'

export default FormConnect



// WEBPACK FOOTER //
// ./src/pages/Form.js